module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon7.6856cc31.svg";